module.exports = __webpack_public_path__ + "static/media/jwoh.6debab1a.jpg";